const updatePos = async ({ params, api }) => {
  const { previousData } = params;
  const { id } = previousData;
  return await api(`pos/${id}`, { body: params.data, method: 'PUT' })
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default updatePos;